import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { DialogLike, DialogService } from "@obg/mat.ui.core";
import { CommonState, CustomerAssessments, CustomerAssessmentsDialogService } from "@obg/ngx.common";
import { DialogStatusSelector } from "@obg/ngx.core";
import { from } from "rxjs";
import { concatMap, filter, map, switchMap, take } from "rxjs/operators";

import { CustomerAssessmentsContainer } from "./customer-assessments.container";

export const CUSTOMER_ASSESSMENTS_DIALOG_ID = "CUSTOMER_ASSESSMENTS_DIALOG";

@Injectable({
	providedIn: "root",
})
export class MatCustomerAssessmentsDialogService implements CustomerAssessmentsDialogService {
	constructor(
		private store: Store<CommonState>,
		private dialogSelector: DialogStatusSelector,
		private dialogService: DialogService
	) {}

	open(assessmentId: string) {
		return this.dialogService.openComponent(this.generateDialog(assessmentId), {
			panelClass: ["obg-m-customer-assessments-dialog"],
			disableClose: true,
			closeOnNavigation: false,
			autoFocus: false,
			width: "auto",
			data: {
				mustBeInteracted: true,
				hideClose: false,
				hideFooter: false,
			},
		});
	}

	openSequentialAssessments(assessments: CustomerAssessments[]) {
		return this.store.select(this.dialogSelector.hasOpenDialogs()).pipe(
			filter((hasDialogs) => !hasDialogs),
			take(1),
			switchMap(() =>
				from(assessments).pipe(
					concatMap((assessment) => this.open(assessment.customerAssessmentId).afterClosed())
				)
			)
		);
	}

	private generateDialog(assessmentId: string): DialogLike<CustomerAssessmentsContainer> {
		return {
			dialogId: CUSTOMER_ASSESSMENTS_DIALOG_ID,
			dialogComponentType: CustomerAssessmentsContainer,
			onBusy$: (component) => component.busy.pipe(map((isBusy) => ({ isBusy }))),
			init: (component) => (component.customerAssessmentId = assessmentId),
		};
	}
}
